import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { Box, Stack } from '@talentmesh/core';
import useTMTranslation from '../../Hooks/useTMTranslation';

const PageFailedLoading = (): React.JSX.Element => {
    const theme = useTheme();
    const { tCommon: t } = useTMTranslation();

    return (
        <Box sx={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Stack alignItems="center">
                <Typography variant="h3" color={theme.palette.text.menuTitle}>
                    {t('OopsSomethingWentWrong')}
                </Typography>
                <Typography variant="body1">{t('PleaseRefresh')}</Typography>
            </Stack>
        </Box>
    );
};

export default PageFailedLoading;
